<template>
  <el-dialog title="新增" :visible="visible" :close-on-click-modal="false" width="900px" @close="handleCancel">
    <el-tabs :value="curTab" type="card">
      <el-tab-pane :label="'商品（' + (tableData.length > 1 ? tableData.length - 1 : 0) + '）'" name="addProduct">
        <el-table ref="gridTable" :data="tableData" class="refundTable" border height="350">
          <el-table-column prop="ItemNo" label="货号" header-align="center" align="center" width="150">
            <template slot-scope="{ row, $index }">
              <el-autocomplete
                placeholder="请输入货号"
                v-model="row.ItemNo"
                :trigger-on-focus="false"
                value-key="ItemNo"
                :fetch-suggestions="searchItemNo"
                @change="handleMatchItemNo(row, $index)"
                @select="handleSeletedItemNo(row, $index, $event)"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column prop="SpecName" label="规格" header-align="center" align="center" width="165">
            <template slot-scope="{ row, $index }">
              {{ row.SpecName }}
              <span v-if="row.ProductID > 0" class="el-icon-edit-outline hand" @click="showSpecDialog(row, $index)"></span>
            </template>
          </el-table-column>
          <el-table-column prop="Num" header-align="center" align="center" label="数量" width="155">
            <template slot-scope="{ row }">
              <el-input-number
                v-model.number="row.Num"
                :min="1"
                size="mini"
                :step="1"
                :precision="0"
                @change="handleNum($event, row)"
                @input="handleNum($event, row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="Price" header-align="center" align="center" label="商品价" width="100"></el-table-column>
          <el-table-column prop="SettlePrice" header-align="center" align="center" label="客户价" width="100"></el-table-column>
          <el-table-column prop="Payment" header-align="center" align="center" label="金额" width="100">
            <template slot-scope="{ row }">
              {{ row.Payment | decimalFormat }}
            </template>
          </el-table-column>
          <el-table-column prop="" header-align="center" align="center" label="操作" width="80">
            <template slot-scope="{ row, $index }">
              <el-button type="danger" @click="handleDelRow($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="'费用（' + (tableFeeData.length > 1 ? tableFeeData.length - 1 : 0) + '）'" name="addFee">
        <el-table ref="gridTable" :data="tableFeeData" class="refundTable" border height="350">
          <el-table-column prop="ItemNo" label="费用名称" header-align="center" align="center" width="270">
            <template slot-scope="{ row, $index }">
              <el-autocomplete
                placeholder="请输入费用名称"
                v-model="row.ItemNo"
                value-key="ItemNo"
                :fetch-suggestions="searchFeeType"
                @change="handleMatchFee(row, $index)"
                @select="handleMatchFee(row, $index)"
              >
              </el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column prop="Payment" header-align="center" align="center" label="金额" width="200">
            <template slot-scope="{ row }">
              <el-input v-model="row.Payment" @input="getStatistics()" v-format.float></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Payment" header-align="center" align="center" label="备注" width="200">
            <template slot-scope="{ row }">
              <el-input v-model="row.Remark"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="" header-align="center" align="center" label="操作" width="180">
            <template slot-scope="{ row, $index }">
              <el-button type="danger" @click="handleDelFeeRow($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer">
      <span style="position: absolute; left: 0; font-size: 18px">
        <span style="font-weight: bold">合计</span>： <span style="color: #f56c6c; padding: 0 5px">{{ form.TotalNum }}</span
        >双 <span style="color: #f56c6c; padding: 0 5px">{{ form.TotalFee }}</span
        >元
      </span>
      <el-button type="default" @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="loading">确定</el-button>
    </div>
    <el-dialog
      v-dialog-drag
      title="选择规格"
      width="400px"
      :visible="selectPropsDialogVisible"
      :close-on-click-modal="false"
      @close="selectPropsDialogVisible = false"
      append-to-body
    >
      <div v-if="SpecData.Colors.length > 0">
        <div class="div_prop_item">颜色：</div>
        <div
          :class="'div_prop_value' + (activeColor && activeColor.Value === item.Value ? ' current' : '')"
          @click="handleColorClick(item)"
          v-for="(item, index) in SpecData.Colors"
          :key="'color-' + index"
        >
          <div :title="item.Value">{{ item.Value }}</div>
        </div>
      </div>
      <div v-if="activeColor" class="mt-20">
        <div class="div_prop_item">尺码：</div>
        <el-button type="text" size="mini" @click="selectAllSizes" class="div_prop_value"> 全选 </el-button>
        <div
          :class="['div_prop_value', item.IsCheck ? ' current' : '']"
          @click="handleSizeClick(activeColor, item)"
          v-for="(item, index) in activeColor.Sizes"
          :key="'size-' + index"
        >
          <div :title="item.Value">{{ item.Value }}</div>
        </div>
      </div>
      <div v-else-if="SpecData.Colors.length > 0" class="mb-10">
        <div class="div_prop_item">尺码：</div>
        <div class="prop-list">
          <div class="div_prop_value disabled">请先选择颜色</div>
        </div>
      </div>
      <div style="margin: 10px 0; padding: 8px; background: #f5f5f5; border-radius: 4px"
        >已选： <br /><span v-html="selectedSpecsDisplay || '暂无选中规格'"></span
      ></div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="selectPropsDialogVisible = false">关闭</el-button>
        <el-button type="primary" size="small" @click="saveSelectPropsDialog">保存</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { submit } from '@/api/base'
export default {
  name: 'AddDetail',
  components: {},
  data() {
    return {
      visible: false,
      curTab: 'addProduct',
      form: {
        TradeID: 0,
        PurchaserID: '',
        PurchaserName: '',
        TotalNum: 0,
        TotalFee: 0,
      },
      tableData: [],
      tableFeeData: [],
      searchItems: [],
      searchFees: [{ ItemNo: '运费' }],
      selectPropsDialogVisible: false,
      SpecData: { ItemNo: null, Specs: null, Colors: [], Sizes: [], Suppliers: [], SupplierID: '', SupplierName: '' },
      loading: false,
      selectedColors: [],
      activeColor: null,
      selectedSpecsDisplay: '',
    }
  },
  methods: {
    isColorSelected(color) {
      return this.selectedColors.some(item => item.Value === color.Value)
    },

    handleColorClick(color) {
      const isSelected = this.selectedColors.some(item => item.Value === color.Value)
      if (!isSelected) {
        const colorWithSizes = { ...color }
        colorWithSizes.Sizes = colorWithSizes.Sizes.map(size => ({ ...size, IsCheck: false }))
        this.selectedColors.push(colorWithSizes)
        this.activeColor = colorWithSizes
      } else {
        this.activeColor = this.selectedColors.find(item => item.Value === color.Value)
      }
      this.updateSelectedSpecsDisplay()
    },
    handleSizeClick(color, size) {
      if (!color || !size) return
      size.IsCheck = !size.IsCheck
      this.updateSelectedSpecsDisplay()
    },

    selectAllSizes() {
      if (!this.activeColor || !this.activeColor.Sizes.length) return
      const allChecked = this.activeColor.Sizes.every(size => size.IsCheck)
      this.activeColor.Sizes.forEach(size => {
        size.IsCheck = !allChecked
      })
      this.updateSelectedSpecsDisplay()
    },

    updateSelectedSpecsDisplay() {
      if (this.selectedColors.length === 0) {
        this.selectedSpecsDisplay = ''
        return
      }
      const displayArr = []
      this.selectedColors.forEach(color => {
        const selectedSizes = color.Sizes.filter(size => size.IsCheck)
          .map(size => size.Value)
          .join('，')
        if (selectedSizes) displayArr.push(`${color.Value}：${selectedSizes}`)
      })
      this.selectedSpecsDisplay = displayArr.join('<br>') || '暂无选中尺码'
    },

    init(purchaser, tradeID) {
      this.visible = true
      this.curTab = 'addProduct'
      this.form.TradeID = tradeID
      this.form.PurchaserID = purchaser.PurchaserID
      this.form.PurchaserName = purchaser.PurchaserName
      this.form.TotalNum = 0
      this.form.TotalFee = 0
      this.tableData = []
      this.tableFeeData = []
      this.searchItems = []
      let _this = this
      this.$nextTick(() => {
        _this.addEmptyRow()
        _this.addFeeEmptyRow()
      })
    },
    //#regioin 商品
    addEmptyRow() {
      if (this.tableData.length == 0 || !this.tableData.some(data => data.ProductID == 0)) {
        this.tableData.push({
          ProductID: 0,
          SpecID: 0,
          ItemNo: '',
          SpecName: '',
          Num: 1,
          Price: 0,
          SettlePrice: 0,
          Payment: 0,
          Cost: 0,
        })
      }
    },
    handleNum(e, row) {
      row.Payment = parseInt(row.Num) * parseFloat(row.SettlePrice)
      this.getStatistics()
    },
    handleDelRow(rowIndex) {
      this.tableData.splice(rowIndex, 1)
      this.getStatistics()
      this.addEmptyRow()
    },
    async searchItemNo(query, callback) {
      if (!query) return callback([])
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        const { data } = await submit('/api/stallRefund/getProductSelectItemNo', {
          Keyword: query,
        })
        callback(data || [])
      }, 300)
    },
    async handleSeletedItemNo(row, rowIndex, selectedRow, fromMatch = false) {
      const { data } = await submit('/api/stallRefund/getProductSelectDetail', {
        ProductID: selectedRow.ProductID,
        CheckStall: true,
        PurchaserID: this.form.PurchaserID,
      })
      if (data) {
        let isSelect = false
        for (var k = 0; k < data.Suppliers.length; k++) {
          let itemData = data.Suppliers[k].detailList[0]
          const item = {
            ...itemData,
            Num: parseInt(row.Num),
            Payment: itemData.SettlePrice * parseInt(row.Num),
            OldItemNo: itemData.ItemNo,
            suppliers: data.Suppliers,
          }
          if (
            !this.tableData.some(
              (x, idx) => idx != rowIndex && x.ProductID == item.ProductID && x.SpecID == item.SpecID && x.SupplierID == item.SupplierID
            )
          ) {
            isSelect = true
            this.tableData.splice(rowIndex, 1, item)
            break
          }
        }
        if (!isSelect) {
          if (fromMatch) {
            this.tableData.splice(rowIndex, 1)
          } else {
            this.tableData[rowIndex].ItemNo = this.tableData[rowIndex].OldItemNo
          }
        }

        this.getStatistics()
        this.$nextTick(() => {
          if (!this.tableData.some(x => x.ProductID == 0)) {
            this.addEmptyRow()
          }
        })
      }
    },
    handleMatchItemNo(row, rowIndex) {
      var that = this
      clearTimeout(that.timeOut)
      that.timeOut = setTimeout(() => {
        let selectedRow = that.searchItems.filter(i => i.ItemNo.toLowerCase() == row.ItemNo.toLowerCase())
        var productIdx = -1
        if (selectedRow.length > 0) {
          for (let i = 0; i < that.tableData.length; i++) {
            if (
              i != rowIndex &&
              that.tableData[i].ProductID == selectedRow[0].ProductID &&
              that.tableData[i].SpecID == selectedRow[0].SpecID
            ) {
              productIdx = i
              break
            }
          }
          if (productIdx < 0) {
            that.handleSeletedItemNo(row, rowIndex, selectedRow[0], true)
          } else {
            that.$baseMessage('已存在货号【' + row.ItemNo + '】的商品', 'error')
            this.handleDelRow(rowIndex)
          }
        } else {
          if (that.tableData[rowIndex].ProductID > 0 && that.tableData[rowIndex].OldItemNo) {
            that.tableData[rowIndex].ItemNo = that.tableData[rowIndex].OldItemNo
          }
          if (that.tableData[rowIndex].ProductID <= 0) {
            this.handleDelRow(rowIndex)
          }
        }
        if (!that.tableData.some(x => x.ProductID == 0)) {
          that.addEmptyRow()
        }
      }, 100)
    },
    async showSpecDialog(row, rowIndex) {
      if (!this.SpecData.ItemNo || this.SpecData.ItemNo != row.ItemNo) {
        const { data, msg } = await submit('/api/stallRefund/getSpecs', {
          ItemNo: row.ItemNo,
          ProductID: row.ProductID,
          CheckStall: false,
          PurchaserID: this.form.PurchaserID,
          PurchaserName: this.form.PurchaserName,
        })
        if (msg) {
          this.$baseMessage(msg)
          return
        }
        const specs = data.Suppliers[0]?.detailList || []

        const buildColorSizeData = supplierSpecs => {
          const colorMap = {}
          supplierSpecs.forEach(spec => {
            const colorKey = spec.Color || '默认颜色'
            if (!colorMap[colorKey]) {
              colorMap[colorKey] = { Value: colorKey, Sizes: [] }
              const sizeSet = new Set()
              supplierSpecs.filter(s => s.Color === colorKey).forEach(s => sizeSet.add(s.Size || '均码'))
              colorMap[colorKey].Sizes = Array.from(sizeSet).map(size => ({ Value: size, IsCheck: false }))
            }
          })
          return Object.values(colorMap)
        }

        this.SpecData = {
          ItemNo: row.ItemNo,
          Specs: specs,
          Colors: buildColorSizeData(specs),
          Index: rowIndex,
        }
      }

      this.selectedColors = []
      this.activeColor = null
      this.selectedSpecsDisplay = ''
      this.selectPropsDialogVisible = true
    },
    //保存选择
    saveSelectPropsDialog() {
      if (this.selectedColors.length === 0) {
        this.$baseMessageBox('请选择至少一个颜色')
        return
      }
      const hasSelectedSize = this.selectedColors.some(color => color.Sizes.some(size => size.IsCheck))
      if (!hasSelectedSize) {
        this.$baseMessageBox('请选择至少一个尺码')
        return
      }

      const baseRow = this.tableData[this.SpecData.Index]
      const newRows = []

      this.selectedColors.forEach(color => {
        color.Sizes.filter(size => size.IsCheck).forEach(size => {
          const matchSpec = this.SpecData.Specs.find(s => s.Color === color.Value && s.Size === size.Value)
          if (matchSpec) {
            newRows.push({
              ...baseRow,
              ...matchSpec,
              SpecName: `${color.Value}-${size.Value}`,
              Num: parseInt(baseRow.Num) || 1,
              Payment: (parseInt(baseRow.Num) || 1) * (matchSpec.SettlePrice || 0),
              SpecID: matchSpec.SpecID || 0,
              ProductID: matchSpec.ProductID || baseRow.ProductID,
            })
          }
        })
      })

      if (newRows.length === 0) {
        this.$baseMessageBox('选择的颜色尺码无对应规格')
        return
      }

      this.tableData.splice(this.SpecData.Index, 1, ...newRows)
      if (!this.tableData.some(row => !row.ProductID)) {
        this.addEmptyRow()
      }

      this.getStatistics()
      this.selectPropsDialogVisible = false
    },
    //#endregion
    //#regioin 费用
    addFeeEmptyRow() {
      if (this.tableFeeData.length == 0 || !this.tableFeeData.some(data => !data.ItemNo)) {
        this.tableFeeData.push({
          ProductID: 0,
          SpecID: 0,
          ItemNo: '',
          SpecName: '',
          Num: 0,
          Price: 0,
          SettlePrice: 0,
          Payment: null,
        })
      }
    },
    async searchFeeType(query, callback) {
      query = query?.toLowerCase()
      var results = query
        ? this.searchFees.filter(item => {
            return item.ItemNo.indexOf(query) >= 0
          })
        : this.searchFees
      callback(results)
    },
    handleMatchFee(row, rowIndex) {
      if (row.ItemNo == row.OldItemNo) {
        return
      }
      if (!row.ItemNo) {
        this.handleDelFeeRow()
        return
      }
      if (this.tableFeeData.some((data, index) => data.ItemNo == row.ItemNo && index != rowIndex)) {
        this.$baseMessage('已存在费用【' + row.ItemNo + '】', 'error')
        this.handleDelFeeRow(rowIndex)
        return
      }
      row.OldItemNo = row.ItemNo
      if (row.Payment) {
        this.getStatistics()
      }
      this.addFeeEmptyRow()
    },
    handleDelFeeRow(rowIndex) {
      this.tableFeeData.splice(rowIndex, 1)
      this.getStatistics()
      this.addFeeEmptyRow()
    },
    //#endregion
    getStatistics() {
      let totalNum = 0,
        totalFee = 0
      this.tableData.forEach(data => {
        if (data.ProductID > 0) {
          totalNum += data.Num
          totalFee += data.Payment
        }
      })
      this.tableFeeData.forEach(data => {
        if (data.ItemNo) {
          totalFee += parseFloat(data.Payment ? data.Payment : 0)
        }
      })
      this.form.TotalNum = totalNum
      this.form.TotalFee = parseFloat(totalFee.toFixed(2))
    },
    async handleSave() {
      this.loading = true
      let saveData = this.getSaveData()
      if (saveData.Error) {
        this.$baseMessage(saveData.Error, 'error')
        this.loading = false
        return
      }
      if (saveData.Details.length <= 0) {
        this.$baseMessage('商品或费用为空', 'error')
        this.loading = false
        return
      }
      let _this = this
      setTimeout(() => {
        _this.loading = false
      }, 2000)
      delete saveData.Error
      await submit('/api/stallCashier/addTradeDetail', saveData)
      this.loading = false
      this.$baseMessage('保存成功', 'success')
      this.$emit('handleSuccess')
      this.handleCancel()
    },
    getSaveData() {
      let saveData = { TradeID: this.form.TradeID, Details: [], Error: '' }
      for (let data of this.tableData) {
        if (data.ProductID > 0) {
          if (!data.Num || data.Num <= 0) {
            saveData.Error = '货号【' + data.ItemNo + '】的数量要大于0'
            break
          }
          delete data.OldItemNo
          saveData.Details.push(data)
        }
      }
      for (let data of this.tableFeeData) {
        if (data.ItemNo) {
          if (data.Payment <= 0) {
            saveData.Error = '费用【' + data.ItemNo + '】的金额要大于0'
            break
          }
          delete data.OldItemNo
          saveData.Details.push(data)
        }
      }
      return saveData
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.mb-10 {
  margin-bottom: 10px;
}

.prop-list {
  display: inline-block;
  margin-left: 10px;
}
.dialog-footer {
  position: relative;

  .checkbox-block {
    position: absolute;
    left: 28px;
    top: 8px;
  }

  .el-button {
    width: 100px !important;
    padding: 10px 10px !important;
  }
}

.div_prop_item {
  display: inline-block;
}

.div_prop_value {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 9px;
  margin-right: 4.5px;
  margin-left: 4.5px;
  padding: 2px;
  font-size: 14px;
  line-height: 14px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  color: #333;
  text-overflow: ellipsis;
  padding: 0 8px;
  white-space: nowrap;
  overflow: hidden;
  line-height: 30px;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  text-align: center;
  position: relative;
}

.div_prop_value.current {
  color: #409eff;
  border-color: #409eff;
  background-color: #fff7f3;
}

.div_prop_value.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: rgba(0, 0, 0, 0.06);
}

.editForm {
  .el-input {
    max-width: 140px;
  }

  ::v-deep {
    .el-form-item__label {
      padding-right: 0px;
    }
  }

  .el-radio {
    margin-left: 10px;
    margin-right: 0px;
  }
}
</style>
